import 'protons';
import './_product.scss';
import './_product.twig';
import './icons/product--narcotic.svg';
import './icons/product--prescription.svg';
import './icons/product--without-prescription.svg';

export const name = 'product';

export const defaults = {};

export function disable() {}

export function enable() {
  const tabTriggersContainer = document.querySelector('.product_variants_btns');
  const tabTriggersTitle = document.querySelectorAll(
    '.product_variants__title span'
  );
  const tabTriggers = document.querySelectorAll('.product__variants__btn');
  const tabPanes = document.querySelectorAll('.product__variant');

  function displayCurrentTab(current) {
    tabPanes.forEach((tabContent, index) => {
      /* eslint-disable no-param-reassign */

      tabContent.style.display = current === index ? 'block' : 'none';
      // Get the associated tab button. We rely on the order in the DOM being the same for buttons and tabs!!!
      // We should improve on that by relating a button to its content using data attributes or something similar.
      tabTriggers[index].classList.toggle('btn-dark', current === index);
      tabTriggers[index].classList.toggle(
        'btn-outline-dark',
        current !== index
      );
    });
    tabTriggersTitle.forEach((tabTitle, index) => {
      tabTitle.style.display = current === index ? 'block' : 'none';
    });
  }

  if (tabTriggersContainer) {
    tabTriggersContainer.addEventListener('click', (event) => {
      // We need the clicked button's index.
      const index = Array.prototype.slice
        .call(tabTriggers)
        .indexOf(event.target);
      displayCurrentTab(index);
    });
  }
}

export default enable;
